<div class="min-feature centerWidth" *ngIf="loaded">
    <div class="main-feature-header col-12 flex flex-wrap ">
        <div class="col-8  md:col-12 feature-title" >
            <h2  style="cursor: pointer;" (click)="goToFeatursPage()">{{title}}</h2></div>
        <div class="col-6  hidden md:block  " >
        </div>
        <div *ngIf="items.scrollWidth>items.offsetWidth && getDirection()=='rtl'" style="height: 55px" class="col-4 md:col-6  next-prev-div" >
            <div class="next-btn {{items.scrollLeft>-1?'btnDisable':''}}" (click)="right(items)">
                <span></span><i class="pi pi-angle-right"></i>
            </div>
            <div class="previous-btn {{items.scrollWidth-1 < (items.offsetWidth+(-1*items.scrollLeft))?'btnDisable':''}} " (click)="left(items)">
                <span></span><i class="pi pi-angle-left"></i>
            </div>
        </div>
        <div *ngIf="items.scrollWidth>items.offsetWidth && getDirection()=='ltr'" style="height: 55px" class="col-4 md:col-6  next-prev-div" >

            <div class="previous-btn {{items.scrollLeft<1?'btnDisable':''}} " (click)="left(items)">
                <span></span><i class="pi pi-angle-left"></i>
            </div>
            <div class="next-btn {{items.scrollLeft>items.offsetWidth?'btnDisable':''}}" (click)="right(items)">
                <span></span><i class="pi pi-angle-right"></i>
            </div>

        </div>
    </div>

    <div  #items dragScroll class="col-12 flex items " style="min-height:400px;">
        <ng-container *ngFor="let page of pages">
            <app-feature-section-item class="col-12 xlg:col-4 lg:col-5 md:col-6  fitem" style="max-width: 405px"
                                      logoPath="{{config.getBaseUrl()+'lnd/file/get_pic?uid=' +page.style.logoImage }}"
                                      title="{{page.title}}"
                                      text="{{page.summary}}"
                                      pageUid="{{page.uid}}"
            ></app-feature-section-item>
        </ng-container>

        <div style="max-width: 405px;" class="col-12 xlg:col-4 lg:col-4 md:col-4  ">
            <div class="see-more">
                <p class="text" i18n="@@View all features">
                    View all features
                </p>
                <div class="more-div">
                    <button class="more-btn button" (click)="goToFeatursPage()"><span i18n="@@See more">See more</span>
                        <i *ngIf="getDirection()=='rtl'" class="pi pi-angle-left"></i>
                        <i *ngIf="getDirection()=='ltr'" class="pi pi-angle-right"></i>
                    </button>
                </div>
            </div>

        </div>
    </div>
</div>